<template>
    <div class="notification is-primary is-light" v-if="is_holiday">
        <p class="is-size-4">
            <span class="icon"><i class="fa-solid fa-triangle-exclamation"></i></span>&nbsp;&nbsp;
            <span v-html="message"></span>
        </p>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data: function () {
        return {
            holidays: [
                { start: '06/20/2025', end: '07/04/2025', message: "WebBank will be closed on Friday, July 4th in observance of Independence Day" },
                { start: '08/18/2025', end: '09/01/2025', message: "WebBank will be closed on Monday, September 1st in observance of Labor Day" },
                { start: '09/29/2025', end: '10/13/2025', message: "WebBank will be closed on Monday, October 13th in observance of Columbus Day" },
                { start: '10/28/2025', end: '11/11/2025', message: "WebBank will be closed on Tuesday, November 11th in observance of Veterans Day" },
                { start: '11/13/2025', end: '11/27/2025', message: "WebBank will be closed on Thursday, November 27th in observance of Thanksgiving" },
                { start: '12/11/2025', end: '12/26/2025', message: "WebBank will be closed on Thursday, December 25th and Friday, December 26th in observance of Christmas" },
                { start: '12/26/2025', end: '01/01/2026', message: "WebBank will be closed on Thursday, January 1st in observance of New Years Day" },

                { start: '01/05/2026', end: '01/19/2026', message: "WebBank will be closed on Monday, January 19th in observance of Martin Luther King Jr. Day" },
                { start: '02/02/2026', end: '02/17/2026', message: "WebBank will be closed on Monday, February 16th in observance of Presidents' Day" },
                { start: '05/11/2026', end: '05/26/2026', message: "WebBank will be closed on Monday, May 25th in observance of Memorial Day" },
                { start: '06/05/2026', end: '06/20/2026', message: "WebBank will be closed on Friday, June 19th in observance of Juneteenth" },
                { start: '06/20/2026', end: '07/04/2026', message: "WebBank will be closed on Friday, July 3rd in observance of Independence Day" },
                { start: '08/24/2026', end: '09/08/2026', message: "WebBank will be closed on Monday, September 7th in observance of Labor Day" },
                { start: '09/28/2026', end: '10/13/2026', message: "WebBank will be closed on Monday, October 12th in observance of Columbus Day" },
                { start: '10/28/2026', end: '11/12/2026', message: "WebBank will be closed on Wednesday, November 11th in observance of Veterans Day" },
                { start: '11/12/2026', end: '11/27/2026', message: "WebBank will be closed on Thursday, November 26th in observance of Thanksgiving" },
                { start: '12/11/2026', end: '12/26/2026', message: "WebBank will be closed on Friday, December 25th in observance of Christmas" },
                { start: '12/26/2026', end: '01/02/2027', message: "WebBank will be closed on Friday, January 1st in observance of New Years Day" },
            ],
            is_holiday: false,
            message: "",
        }
    },

    mounted() {
        this.notifyHolidays();
    },

    methods: {
        notifyHolidays: function () {
            let now = moment();
            // console.log('current time: ' + now);
            for (let x in this.holidays) {
                // console.log('start: ' + this.holidays[x].start);

                let modstart = this.modifyDate(this.holidays[x].start);
                // console.log('modstart: ' + modstart);

                let starttime = moment(modstart);
                // console.log('starttime: ' + starttime);
                if (starttime < now) {
                    // console.log('+++ START TIME IS LESS THAN NOW! +++');

                    let modend = this.modifyDate(this.holidays[x].end);
                    // console.log('modend: ' + modend);

                    let endtime = moment(modend);
                    // console.log('endtime: ' + endtime);
                    if (endtime > now) {
                        // console.log('+++ END TIME IS GREATER THAN NOW! +++');
                        this.is_holiday = true;
                        this.message += this.holidays[x].message + "<br>";
                    }
                }

                // console.log('end: ' + this.holidays[x].end);
                // console.log('message: ' + this.holidays[x].message);
            }
        },

        modifyDate: function (string) {
            let parts = string.split("/");
            let month = parts[0];
            if (month < 10 && month.length < 2) {
                month = "0" + month;
            }
            let day = parts[1];
            if (day < 10 && day.length < 2) {
                day = "0" + day;
            }
            return parts[2] + "-" + month + "-" + day;
        }
    }
}
</script>
